import { csrfTokenHeader } from "@circle-react/helpers/csrfToken";
import { safeJsonParse } from "@circle-react/helpers/safeJsonParse";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import { fetchEventSource } from "@microsoft/fetch-event-source";

export const useCompletionsStream = () => {
  const [isLoading, toggleIsLoading] = useBoolean(false);

  const createCompletion = async ({
    type,
    previous_text = "",
    user_prompt,
    title,
    onOpen,
    onMessage,
    onClose,
    onError,
  }) => {
    toggleIsLoading(true);
    await fetchEventSource("/internal_api/copilot/completions", {
      method: "POST",
      body: JSON.stringify({
        context: {
          title,
          previous_text,
          type,
          user_prompt,
        },
      }),
      headers: {
        Accept: "text/event-stream",
        "Content-Type": "application/json",
        ...csrfTokenHeader(),
      },
      onopen(res) {
        if (res.ok && res.status === 200) {
          onOpen();
        } else if (
          res.status >= 400 &&
          res.status < 500 &&
          res.status !== 429
        ) {
          toggleIsLoading(false);
          onError?.();
        }
      },
      onmessage(event) {
        const parsedData = safeJsonParse(event.data);
        if (parsedData?.content) {
          onMessage(parsedData.content);
        }
      },
      onclose() {
        toggleIsLoading(false);
        onClose();
      },
      onerror(e) {
        toggleIsLoading(false);
        onError?.();
        throw e;
      },
    });
  };

  return { createCompletion, isLoading };
};
